import axios from "axios";
import Config from "config";

  // INSERT TRADE curl -X POST "https://" + Config.takyon_domain + "/user_trades?user_id=1&exchange=alpaca" -d '[ { "user_id": 1, "exchange": "alpaca", "pair": "SERV", "trade_id": "998877315", "order_id": "99887735-c47d-4539-a9d8-998877665315", "time": 1771715828995, "side": "buy", "order_type": "limit", "price": "9.58", "qty": "25.0", "fee": "2.00" }]

export const buyOrder = async (data) => {
  const { coin, accountId, paymentMethod, amount, accessToken, price, timestamp, order_id, trade_id } = data;
  const { commit } = data || true;

  const postdata = [ 
        { 
            "user_id": 1, 
            "exchange": "alpaca", 
            "pair": coin,
            "trade_id": trade_id, // "99887735",
            "order_id": order_id, // "99887735-c47d-4539-a9d8-998877665315", 
            "time": timestamp,
            "side": "buy", 
            "order_type": "limit", 
            "price": price,
            "qty": amount,
            "fee": "2.00" 
        }
  ];

  console.log( 'SAMEER ----------- buyOrder ----------------');
  console.log( data);
  console.log( postdata);
  const response = await axios.post(
    `https://${Config.takyon_domain}/user_trades?user_id=1&exchange=alpaca`,
    postdata, 
    {
      headers: {
        Accept: "*",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  )
  .then( (response) => {
    console.log( 'SAMEER ----------- buyOrder response 1. ----------------');
    console.log( response);

    const nresp = { accountId, confirm: response.data.id, payload: response.data };
    console.log(nresp);
    return nresp;
  })
  .catch( (err) => {
    console.log( 'SAMEER --!! Error- buyOrder response ----------------');
    console.log(err);
    return {accountId, confirm: -1, payload: {}};
  });

  return response;
};

export const sellOrder = async (data) => {
  const { coin, accountId, paymentMethod, amount, accessToken, price, timestamp, order_id, trade_id } = data;
  const { commit } = data || true;

  const postdata = [ 
        { 
            "user_id": 1, 
            "exchange": "alpaca", 
            "pair": coin,
            "trade_id": trade_id, // "99887735",
            "order_id": order_id, // "99887735-c47d-4539-a9d8-998877665315", 
            "time": timestamp,
            "side": "sell", 
            "order_type": "limit", 
            "price": price,
            "qty": amount,
            "fee": "2.00" 
        }
  ];

  console.log( 'SAMEER ----------- sellOrder ----------------');
  console.log( data);
  console.log( postdata);
  const response = await axios.post(
    `https://${Config.takyon_domain}/user_trades?user_id=1&exchange=alpaca`,
    postdata, 
    {
      headers: {
        Accept: "*",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  )
  .then( (response) => {
    console.log( 'SAMEER ----------- sellOrder response ----------------');
    console.log( response);
    return { accountId, confirm: response.data.id, payload: response.data };
  })
  .catch( (err) => {
    console.log( 'SAMEER --!! Error- sellOrder response ----------------');
    console.log(err);
    return {accountId, confirm: -1, payload: {}};
  });
};

export const commitOrder = async (data) => {
  const { accountId, buyId, accessToken, resource } = data;

  const side = resource === "buy" ? "buys" : "sells";

  const response = await axios.post(
    `http://api.coinbase.com/v2/accounts/${accountId}/${side}/${buyId}/commit`,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "CB-VERSION": "2021-12-13",
      },
    }
  );

  return { payload: response.data };
};

export const fetchPaymetnMethods = async ({ accessToken }) => {
  // const accessToken = "1234";
  const paymentsMethodconfig = {
    method: "get",
    url: "http://api.coinbase.com/v2/payment-methods",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "CB-VERSION": "2021-12-13",
    },
  };

  const response = await axios(paymentsMethodconfig);

  return response.data;
};
